<template>
    <div id="app">
        <vue-page-transition name="fade">
            <router-view />
        </vue-page-transition>
    </div>
</template>

<script>
export default {
    name: 'App',
    mounted() {
        console.log(this.$store.getters.isAuthenticated)
        if (this.$route.name == 'logout' || this.$route.name == 'callback') return
        if (this.$store.getters.isAuthenticated) {
            this.$auth.checkSession().then(result => {
                this.$store.commit('REFRESH', result)
            })
        }
    },
}
</script>

<style>
#app {
    height: 100%;
    width: 100%;
}
.navbar {
    /* background:#10122d;
  box-shadow: 0px -3px 15px black; */
    background: #fd5d93;
}
.navbar.navbar-transparent {
    box-shadow: none;
}
body,
.card-category,
.category {
    font-size: 1rem;
}
.btn-neutral:not([data-action]):hover {
    transform: translateY(0px) !important;
    -webkit-transform: translateY(0px) !important;
}
.btn-danger {
    background: #e32e1e;
    background-image: linear-gradient(to bottom left, #df2218, #e32e1e, #e32e1e);
}
.btn-danger.active,
.btn-danger.active:focus,
.btn-danger.active:hover,
.btn-danger:active,
.btn-danger:active:focus,
.btn-danger:active:hover,
.btn-danger:focus,
.btn-danger:hover {
    background-image: linear-gradient(to bottom left, #df2218, #e32e1e, #e32e1e) !important;
}
.modal-backdrop.show {
    opacity: 1;
}
.modal-backdrop {
    background: rgba(0, 0, 0, 0.6);
}

.form-group .form-control + .input-group-append .input-group-text,
.form-group .form-control + .input-group-prepend .input-group-text,
.input-group .form-control + .input-group-append .input-group-text,
.input-group .form-control + .input-group-prepend .input-group-text {
    padding: 10px;
    font-weight: 300;
    color: hsla(0, 0%, 100%, 0.6);
    font-size: 80%;
    background-color: #16191c;
}
a.input-group-text {
    cursor: pointer;
}
.input-group .form-control + .input-group-append span.input-group-text {
    padding: 0 15px;
}
.form-control {
    background-color: #16191c;
}
.index-page p {
    font-size: 1em;
}

#questionsmodal .modal-content .modal-body .reactionemoji img {
    padding: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue